import React, { useEffect, useReducer, createContext } from 'react';
import { format, parse } from 'date-fns';
import { fetchMetaData, fetchStatuswiseRevenueDates } from '../actions/actionSelectors';
import { FETCH_DATA_REQUEST, FETCH_DATE_CONFIG, SET_REVENUE_DATE, SET_SHOW_INSTRUCTION_MODEL,
         RESET_SUBMITTED_AND_ERROR_FLAGS, DISPLAY_ERROR_MESSAGE, DATE_CHANGE_FLAG, DATE_CHANGED, 
         FETCH_STATUS_WISE_REVENUE_DATES, SET_CHANGE_REQUEST_NUMBER, SET_REVENUE_DATA_LOADING_FLAG, 
         SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE, SET_WEEKLY_START_DATE, SET_WEEKLY_END_DATE,
         WEEKLY_DATE_CHANGE_FLAG, SET_RAW_DATE_HANDLER, SET_RAW_DATE } from '../actions/actionTypes';
import { revenueCalendarReducer } from '../actions/revenue-calendar-reducer';

const initialState = {
    revenueDate: null,
    minDate: null,
    maxDate: null,
    sessionTimeoutLimit: null,
    idleTimeoutLimit: null,
    isLoading: false,
    isError: false,
    errorMessage: undefined,
    isSuccessfulSubmitted: false,
    showModel: false,
    showInstructions: false,
    modelHeaderTitle: "",
    isFileImportedSuccessfully: false,
    isDateChangeFlag : false,
    isDateChanged : true,
    newSelectedDate : null,
    oldSelectedDate : null,
    statusWiseRevenueDates: null,
    changeReqNumber: null,
    requestStatus: 0,
    dataLoading: false,
    unblockFromDate: null,
    selectedContractCodeValue: null,
    weeklyStartDate: null,
    weeklyEndDate: null,
    isMonthlyRevenueSubmitted: false,
    contractCodeList: null,
    newWeeklyStartDate : null,
    oldWeeklyStartDate : null,
    newWeeklyEndDate : null,
    oldWeeklyEndDate: null,
    rawDateError: ""
}

export const RevenueCalendarContext = createContext();

export function RevenueCalendarProvider(props) {
    const [state, dispatch] = useReducer(revenueCalendarReducer, initialState);

    const { revenueDate, minDate, maxDate, sessionTimeoutLimit, idleTimeoutLimit, isLoading, isError,
        isSuccessfulSubmitted, errorMessage, showModel, showInstructions, modelHeaderTitle, 
        isFileImportedSuccessfully, isDateChanged, newSelectedDate, oldSelectedDate, isDateChangeFlag, 
        statusWiseRevenueDates, changeReqNumber, requestStatus, dataLoading, unblockFromDate, 
        selectedContractCodeValue, weeklyStartDate, weeklyEndDate, isMonthlyRevenueSubmitted, contractCodeList,
        newWeeklyStartDate, oldWeeklyStartDate, newWeeklyEndDate, oldWeeklyEndDate, rawDateError
    } = state;

    const ShowOrHideLoader = (loading) => {
        dispatch({ type: FETCH_DATA_REQUEST, 
                payload: { 
                    isLoading: loading, 
                    isError: false, errorMessage: "" 
                } 
            }
        );
    }        

    const setErrorOrWarningHandler = (isModelError, errorModelMessage, isLoadingError, 
        showErrorModel, modelHeaderTitleError, isFileUploaded, isSubmitted, reqStatus, isMonRevenueSubmitted, conCodeList) => {         
        dispatch({
            type: DISPLAY_ERROR_MESSAGE,
            payload: {
                isError: isModelError,
                errorMessage: errorModelMessage,
                isLoading: isLoadingError,
                showModel: showErrorModel,
                modelHeaderTitle: modelHeaderTitleError,  
                isFileImportedSuccessfully: isFileUploaded,
                isSuccessfulSubmitted: isSubmitted,
                requestStatus : !reqStatus ? 0 : reqStatus,
                isMonthlyRevenueSubmitted: isMonRevenueSubmitted,
                contractCodeList : conCodeList
            }
        });
    }

    const setRevenueDate = (revDate) => {
        dispatch({ type: SET_REVENUE_DATE, payload: { revenueDate: revDate } });  
    }

    const revenueDateHandler = (selectedDate, oSelectedDate) => {
         dispatch(
                    {   type: DATE_CHANGE_FLAG, 
                        payload: { 
                                newSelectedDate: format(selectedDate, "dd/MM/yyyy") ,
                                oldSelectedDate: format(oSelectedDate, "dd/MM/yyyy")
                        }
                    }
        );
    }

    useEffect(() => {
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));

        async function fetchMetaDataAsync() {

            await fetchMetaData()
                .then((data) => {
                    dispatch({
                        type: FETCH_DATE_CONFIG,
                        payload: {
                            revenueDate: !props.isWeekly ? data.StartDate : null,
                            minDate: data.MinDate,
                            maxDate: data.MaxDate,
                            weeklyStartDate: props.isWeekly ? data.weeklyStartDate: null,
                            weeklyEndDate: props.isWeekly ? data.weeklyEndDate: null,
                            sessionTimeoutLimit: data.sessionTimeoutLimit && data.sessionTimeoutLimit !== "" ? +(data.sessionTimeoutLimit) : null,
                            idleTimeoutLimit: data.idleTimeoutLimit && data.idleTimeoutLimit !== "" ? +(data.idleTimeoutLimit) : null
                        }
                    });
                    data.MinDate && data.MaxDate && fetchStatuswiseRevenueDatesHandler(data.MinDate, data.MaxDate, false);
                })
                .catch((error) => {
                    setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
                })
        }
        fetchMetaDataAsync();
    }, []);

    const setChangeRequestNumber = (crNumber) =>{
        dispatch({
            type: SET_CHANGE_REQUEST_NUMBER,
            payload: {
                changeReqNumber : crNumber
            }
        })
    }

    const resetSubmittedAndErrorFlags = () => {
        dispatch({ type: RESET_SUBMITTED_AND_ERROR_FLAGS });
        
        if (isDateChangeFlag) {
            if (props.isWeekly && oldWeeklyStartDate && oldWeeklyEndDate) {
                setWeeklyStartDate(oldWeeklyStartDate);
                setWeeklyEndDate(oldWeeklyEndDate);
            } else {
                setRevenueDate(oldSelectedDate);
            }
            dispatch({ type: DATE_CHANGED , payload: { isDateChanged: isDateChanged && isDateChanged === true ? false : true }  });
        }
        props.setLogoutFalse();
    }

    const setShowInstructions = (showInstructionsModel) => {
        dispatch({
            type: SET_SHOW_INSTRUCTION_MODEL,
            payload: {
                showModel: showInstructionsModel,
                showInstructions: showInstructionsModel,
                modelHeaderTitle: showInstructionsModel ? "instruction" : ""
            }
        })
    }

    const setErrorPopUpHandler = (msg, title) => {
        setErrorOrWarningHandler(true, msg ? msg : "all_mandatory", false, true, title ? title : "dailyrevenue", false, false)
    }

    /* status wise revenue date */
    const fetchStatuswiseRevenueDatesHandler = async (mnDate, mxDate, isSubmitted) => {
        await fetchStatuswiseRevenueDates(mnDate, mxDate, props.BusinessPartnerCode)
            .then((data) => {
                dispatch({
                    type: FETCH_STATUS_WISE_REVENUE_DATES,
                    payload: {
                        statusWiseRevenueDates: data && typeof(data) !== 'string' ? data : null
                    }
                });
            })
            .catch((error) => {
                if(!isSubmitted) {
                    setErrorOrWarningHandler(true, "wentwrong", false, true, "dailyrevenue", false, false);
                }
            })
    }
    
    const handleConfirmationYesClick = () => {
        if(props.isLogout) {
            props.clearSessionData();
        } else if (isDateChangeFlag)
        {
            if (props.isWeekly && newWeeklyStartDate && newWeeklyEndDate) {
                setWeeklyStartDate(newWeeklyStartDate);
                setWeeklyEndDate(newWeeklyEndDate);
            } else {
                setRevenueDate(newSelectedDate);
            }
        }
    }

    const setRevenueDataLoadingFlag = (isDataLoading) =>{
        dispatch({
            type: SET_REVENUE_DATA_LOADING_FLAG,
            payload: {
                dataLoading : isDataLoading
            }
        })
    }

    const setUnblockFromDateAndContractCode = (fDate, contractCode) =>{
        dispatch({
            type: SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE,
            payload: {
                unblockFromDate : fDate,
                selectedContractCodeValue: contractCode
            }
        })
    }

    const setWeeklyStartDate = (sDate) => {
        dispatch({type: SET_WEEKLY_START_DATE, payload: {weeklyStartDate: sDate}});
    }

    const setWeeklyEndDate = (eDate) => {
        dispatch({type: SET_WEEKLY_END_DATE, payload: {weeklyEndDate: eDate}});
    }

    const weeklyDateHandler = (wStartDate, wOldStartDate, wEndDate, wOldEndDate) => {
        dispatch(
            {   type: WEEKLY_DATE_CHANGE_FLAG, 
                payload: { 
                    newWeeklyStartDate: format(wStartDate, "dd/MM/yyyy") ,
                    oldWeeklyStartDate: format(wOldStartDate, "dd/MM/yyyy"),
                    newWeeklyEndDate: format(wEndDate, "dd/MM/yyyy") ,
                    oldWeeklyEndDate: format(wOldEndDate, "dd/MM/yyyy")
                }
            }
       );
    }

    const setRawDateHandler = (ev) => {
        let dateValError = "";
        if (ev.currentTarget.value &&
            parse(ev.currentTarget.value, "dd/MM/yyyy", new Date()) == 'Invalid Date') {
            dateValError = "valid_date";
        }
        dispatch({ type: SET_RAW_DATE_HANDLER, payload: { rawDateError: dateValError } });
    }

    const setRawDate = () => {
        let dateValError = "";
        dispatch({ type: SET_RAW_DATE, payload: { rawDateError: dateValError } });
    }

    const provider = {
        revenueDate:revenueDate, 
        minDate:minDate, 
        maxDate, 
        sessionTimeoutLimit, 
        idleTimeoutLimit, 
        isLoading, 
        isError,
        isSuccessfulSubmitted, 
        errorMessage, 
        showModel, 
        showInstructions, 
        modelHeaderTitle, 
        isFileImportedSuccessfully, 
        isDateChanged: isDateChanged, 
        newSelectedDate, 
        oldSelectedDate, 
        isDateChangeFlag, 
        statusWiseRevenueDates, 
        changeReqNumber,
        requestStatus,
        dataLoading,
        unblockFromDate,
        selectedContractCodeValue,
        weeklyStartDate,
        weeklyEndDate,
        revenueDateHandler: revenueDateHandler,
        fetchStatuswiseRevenueDatesHandler,
        setShowInstructions: setShowInstructions,
        ShowOrHideLoader,
        resetSubmittedAndErrorFlags: resetSubmittedAndErrorFlags,      
        setErrorPopUpHandler: setErrorPopUpHandler,     
        handleConfirmationYesClick: handleConfirmationYesClick,
        setChangeRequestNumber,
        setErrorOrWarningHandler,
        setRevenueDate,
        setRevenueDataLoadingFlag,
        setUnblockFromDateAndContractCode,
        setWeeklyStartDate,
        setWeeklyEndDate,
        isMonthlyRevenueSubmitted,
        contractCodeList,
        newWeeklyStartDate, 
        oldWeeklyStartDate, 
        newWeeklyEndDate, 
        oldWeeklyEndDate,
        weeklyDateHandler,
        rawDateError,
        setRawDateHandler,
        setRawDate
    }

    return (
        <RevenueCalendarContext.Provider value={provider}>
            {props.children}
        </RevenueCalendarContext.Provider>
    );
}        
